import { Item } from "../model/item";
import { State } from ".";

export const getItems = (state: State, date: string): Array<Item> => {
    const dayData = state.data.days[date];
    const dateItems = dayData && dayData.present;
    return dateItems;
};
